import type { IProspectStatusBadge } from '../interfaces/prospects';
import { TRANSLATIONS_PROSPECTS } from '../translations/prospects';
import type { BadgeVariant } from '../types/globals';
import { ProspectSalesModel, type ProspectStatus } from '../types/prospects';

export const EIN_DOCUMENT_TYPE = 'EIN';
export const MIN_HEADCOUNT_FOR_BENEFITS = 50;
export const SKELETON_COUNT = 4;
export const DEFAULT_COUNTRY_CODE = 'US';

export const ACTIVATION_MIN_LEAD_DAYS_APP_ONLY = 0;
export const ACTIVATION_MIN_LEAD_DAYS_WITH_INSURER = 14;
export const ACTIVATION_MIN_LEAD_DAYS_APP_ONLY_WITH_DOCS = 14;

export const SALES_MODEL_ORDER: ProspectSalesModel[] = [ProspectSalesModel.AppAndInsurance, ProspectSalesModel.AppOnly];

export const SALES_MODEL_COPY: Record<ProspectSalesModel, { title: string; description: string }> = {
  [ProspectSalesModel.AppAndInsurance]: {
    title: TRANSLATIONS_PROSPECTS.forms.salesModel.appAndInsurance.title,
    description: TRANSLATIONS_PROSPECTS.forms.salesModel.appAndInsurance.description
  },
  [ProspectSalesModel.AppOnly]: {
    title: TRANSLATIONS_PROSPECTS.forms.salesModel.appOnly.title,
    description: TRANSLATIONS_PROSPECTS.forms.salesModel.appOnly.description
  }
};

export const PROSPECT_STATUS_BADGE_VARIANT: Record<ProspectStatus, BadgeVariant> = {
  pending_quote: 'pending',
  quoted: 'quoted',
  pending_activation: 'pending-activation',
  lost: 'lost',
  inactive: 'inactive'
};

export const PROSPECT_STATUS_LABEL: Record<ProspectStatus, string> = {
  pending_quote: 'prospects.detail.status.pending_quote',
  quoted: 'prospects.detail.status.quoted',
  pending_activation: 'prospects.detail.status.pending_activation',
  lost: 'prospects.detail.status.lost',
  inactive: 'prospects.detail.status.inactive'
};

export const PROSPECT_STATUS_BADGE: Record<string, IProspectStatusBadge> = {
  pending_quote: { variant: 'pending', labelKey: TRANSLATIONS_PROSPECTS.status.pending_quote },
  quoted: { variant: 'quoted', labelKey: TRANSLATIONS_PROSPECTS.status.quoted },
  pending_activation: { variant: 'pending-activation', labelKey: TRANSLATIONS_PROSPECTS.status.pending_activation },
  inactive: { variant: 'inactive', labelKey: TRANSLATIONS_PROSPECTS.status.inactive },
  lost: { variant: 'lost', labelKey: TRANSLATIONS_PROSPECTS.status.lost }
};
